const symbolsRegexp = new RegExp(`[$&+,:;=?@#|<>.^*%!]+`, 'g');
const roomRegexp = new RegExp(`^room\\s+|\\s+room|room`, 'gi');
const viewRegexp = new RegExp(/(\w+)(view)/gi);

function toTitleCase(text: string) {
    return text
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function cutDups(text: string) {
    let arr = text.split(' ');
    return arr.filter((e, i) => arr.indexOf(e) === i).join(' ');
}

export function normalize(roomType: string): string {
    const temp = roomType;

    let res = roomType
        .trim()
        .toLowerCase();

    res = res.replace(symbolsRegexp, '');
    res = res.replace(viewRegexp, '$1 $2');
    res = res.replace(roomRegexp, '');
    res = res.replace('standart', 'standard');

    res = cutDups(res);

    res = toTitleCase(res);

    if (res === '') {
        console.warn(`original:"${temp}", res:"${res}"`);
    }

    return res;
}
